<div class="add-container">
    <h1 class="add-title">Adaugă registru</h1>
    <form class="add-card__form" [formGroup]="form" (submit)="submitForm()">
        <div *ngIf="data.registru_slug === 'acord-de-functionare' || data.registru_slug === 'acord-comercializare'">
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Număr Acord/Autorizație</mat-label>
                        <input type="number" matInput formControlName="document_numar" />
                        <mat-error *ngIf="
                            !form.controls['document_numar'].valid &&
                            form.controls['document_numar'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Data eliberării Acord/Autorizație</mat-label>
                        <input matInput [matDatepicker]="picker_document_data" formControlName="document_data" readonly
                            (focus)="picker_document_data.open()" />
                        <mat-error *ngIf="
                            !form.controls['document_data'].valid &&
                            form.controls['document_data'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                        <mat-hint>ZZ/LL/AAAA</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker_document_data"></mat-datepicker-toggle>
                        <mat-datepicker #picker_document_data></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Denumire Firmă/Societate </mat-label>
                        <input type="text" matInput formControlName="f_nume" />
                        <mat-error *ngIf="
                            !form.controls['f_nume'].valid &&
                            form.controls['f_nume'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>CUI Firmă/Societate</mat-label>
                        <input type="number" matInput formControlName="f_cui" />
                        <mat-error *ngIf="
                            !form.controls['f_cui'].valid &&
                            form.controls['f_cui'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Număr cerere</mat-label>
                        <input type="number" matInput formControlName="cerere_numar" />
                        <mat-error *ngIf="
                            !form.controls['cerere_numar'].valid &&
                            form.controls['cerere_numar'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Dată Cerere</mat-label>
                        <input matInput [matDatepicker]="picker_cerere_data" formControlName="cerere_data" readonly
                            (focus)="picker_cerere_data.open()" />
                        <mat-error *ngIf="
                            !form.controls['cerere_data'].valid &&
                            form.controls['cerere_data'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                        <mat-hint>ZZ/LL/AAAA</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker_cerere_data"></mat-datepicker-toggle>
                        <mat-datepicker #picker_cerere_data></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Număr Aviz</mat-label>
                        <input type="text" matInput formControlName="aviz_numar" />
                        <mat-error *ngIf="
                            !form.controls['aviz_numar'].valid &&
                            form.controls['aviz_numar'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Dată Aviz</mat-label>
                        <input matInput [matDatepicker]="picker_aviz_data" formControlName="aviz_data" readonly
                            (focus)="picker_aviz_data.open()" />
                        <mat-error *ngIf="
                            !form.controls['aviz_data'].valid &&
                            form.controls['aviz_data'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                        <mat-hint>ZZ/LL/AAAA</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker_aviz_data"></mat-datepicker-toggle>
                        <mat-datepicker #picker_aviz_data></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Sediu Social</mat-label>
                        <textarea type="text" matInput formControlName="f_sediu"></textarea>
                        <mat-error *ngIf="
                            !form.controls['f_sediu'].valid &&
                            form.controls['f_sediu'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Punct de lucru</mat-label>
                        <textarea type="text" matInput formControlName="f_punct_lucru"></textarea>
                        <mat-error *ngIf="
                            !form.controls['f_punct_lucru'].valid &&
                            form.controls['f_punct_lucru'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>CAEN</mat-label>
                        <input type="text" matInput formControlName="obiect_activitate" />
                        <mat-error *ngIf="
                            !form.controls['obiect_activitate'].valid && form.controls['obiect_activitate'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Valabilitate</mat-label>
                        <input matInput [matDatepicker]="picker_valability" formControlName="valability" readonly
                            (focus)="picker_valability.open()" />
                        <mat-error *ngIf="
                            !form.controls['valability'].valid &&
                            form.controls['valability'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                        <mat-hint>ZZ/LL/AAAA</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker_valability"></mat-datepicker-toggle>
                        <mat-datepicker #picker_valability></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="add-field col-md-12">
                    <mat-form-field appearance="fill">
                        <mat-label>Orar de functionare</mat-label>
                        <textarea type="text" matInput formControlName="orar_functionare"></textarea>
                        <mat-error *ngIf="
                            !form.controls['orar_functionare'].valid &&
                            form.controls['orar_functionare'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div *ngIf="data.registru_slug === 'acord-temporar'">
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Număr Acord/Autorizație</mat-label>
                        <input type="number" matInput formControlName="document_numar" />
                        <mat-error *ngIf="
                            !form.controls['document_numar'].valid &&
                            form.controls['document_numar'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Data eliberării Acord/Autorizație</mat-label>
                        <input matInput [matDatepicker]="picker_document_data" formControlName="document_data" readonly
                            (focus)="picker_document_data.open()" />
                        <mat-error *ngIf="
                            !form.controls['document_data'].valid &&
                            form.controls['document_data'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                        <mat-hint>ZZ/LL/AAAA</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker_document_data"></mat-datepicker-toggle>
                        <mat-datepicker #picker_document_data></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Denumire Firmă/Societate </mat-label>
                        <input type="text" matInput formControlName="f_nume" />
                        <mat-error *ngIf="
                            !form.controls['f_nume'].valid &&
                            form.controls['f_nume'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>CUI Firmă/Societate</mat-label>
                        <input type="number" matInput formControlName="f_cui" />
                        <mat-error *ngIf="
                            !form.controls['f_cui'].valid &&
                            form.controls['f_cui'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Număr cerere</mat-label>
                        <input type="number" matInput formControlName="cerere_numar" />
                        <mat-error *ngIf="
                            !form.controls['cerere_numar'].valid &&
                            form.controls['cerere_numar'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Dată Cerere</mat-label>
                        <input matInput [matDatepicker]="picker_cerere_data" formControlName="cerere_data" readonly
                            (focus)="picker_cerere_data.open()" />
                        <mat-error *ngIf="
                            !form.controls['cerere_data'].valid &&
                            form.controls['cerere_data'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                        <mat-hint>ZZ/LL/AAAA</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker_cerere_data"></mat-datepicker-toggle>
                        <mat-datepicker #picker_cerere_data></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Punct de lucru</mat-label>
                        <textarea type="text" matInput formControlName="f_punct_lucru"></textarea>
                        <mat-error *ngIf="
                            !form.controls['f_punct_lucru'].valid &&
                            form.controls['f_punct_lucru'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Valabilitate</mat-label>
                        <input matInput [matDatepicker]="picker_valability" formControlName="valability" readonly
                            (focus)="picker_valability.open()" />
                        <mat-error *ngIf="
                            !form.controls['valability'].valid &&
                            form.controls['valability'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                        <mat-hint>ZZ/LL/AAAA</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker_valability"></mat-datepicker-toggle>
                        <mat-datepicker #picker_valability></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Suprafață</mat-label>
                        <input type="number" matInput formControlName="suprafata" />
                        <mat-error *ngIf="
                            !form.controls['suprafata'].valid &&
                            form.controls['suprafata'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Tip mobilier</mat-label>
                        <mat-select formControlName="tip_mobilier">
                            <mat-option *ngFor="let tip of tipuriMobilier" [value]="tip.id">
                                {{ tip.name }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="
                            !form.controls['tip_mobilier'].valid &&
                            form.controls['tip_mobilier'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div *ngIf="data.registru_slug === 'autorizatie-alimentatie-publica'">
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Număr Acord/Autorizație</mat-label>
                        <input type="number" matInput formControlName="document_numar" />
                        <mat-error *ngIf="
                            !form.controls['document_numar'].valid &&
                            form.controls['document_numar'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Data eliberării Acord/Autorizație</mat-label>
                        <input matInput [matDatepicker]="picker_document_data" formControlName="document_data" readonly
                            (focus)="picker_document_data.open()" />
                        <mat-error *ngIf="
                            !form.controls['document_data'].valid &&
                            form.controls['document_data'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                        <mat-hint>ZZ/LL/AAAA</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker_document_data"></mat-datepicker-toggle>
                        <mat-datepicker #picker_document_data></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Denumire Firmă/Societate </mat-label>
                        <input type="text" matInput formControlName="f_nume" />
                        <mat-error *ngIf="
                            !form.controls['f_nume'].valid &&
                            form.controls['f_nume'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>CUI Firmă/Societate</mat-label>
                        <input type="number" matInput formControlName="f_cui" />
                        <mat-error *ngIf="
                            !form.controls['f_cui'].valid &&
                            form.controls['f_cui'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Număr cerere</mat-label>
                        <input type="number" matInput formControlName="cerere_numar" />
                        <mat-error *ngIf="
                            !form.controls['cerere_numar'].valid &&
                            form.controls['cerere_numar'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Dată Cerere</mat-label>
                        <input matInput [matDatepicker]="picker_cerere_data" formControlName="cerere_data" readonly
                            (focus)="picker_cerere_data.open()" />
                        <mat-error *ngIf="
                            !form.controls['cerere_data'].valid &&
                            form.controls['cerere_data'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                        <mat-hint>ZZ/LL/AAAA</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker_cerere_data"></mat-datepicker-toggle>
                        <mat-datepicker #picker_cerere_data></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Punct de lucru</mat-label>
                        <textarea type="text" matInput formControlName="f_punct_lucru"></textarea>
                        <mat-error *ngIf="
                            !form.controls['f_punct_lucru'].valid &&
                            form.controls['f_punct_lucru'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Valabilitate</mat-label>
                        <input matInput [matDatepicker]="picker_valability" formControlName="valability" readonly
                            (focus)="picker_valability.open()" />
                        <mat-error *ngIf="
                            !form.controls['valability'].valid &&
                            form.controls['valability'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                        <mat-hint>ZZ/LL/AAAA</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker_valability"></mat-datepicker-toggle>
                        <mat-datepicker #picker_valability></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>CAEN</mat-label>
                        <input type="number" matInput formControlName="obiect_activitate" />
                        <mat-error *ngIf="
                            !form.controls['obiect_activitate'].valid &&
                            form.controls['obiect_activitate'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div *ngIf="data.registru_slug === 'autorizatie-piata-targ'">
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Număr Acord/Autorizație</mat-label>
                        <input type="number" matInput formControlName="document_numar" />
                        <mat-error *ngIf="
                            !form.controls['document_numar'].valid &&
                            form.controls['document_numar'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Data eliberării Acord/Autorizație</mat-label>
                        <input matInput [matDatepicker]="picker_document_data" formControlName="document_data" readonly
                            (focus)="picker_document_data.open()" />
                        <mat-error *ngIf="
                            !form.controls['document_data'].valid &&
                            form.controls['document_data'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                        <mat-hint>ZZ/LL/AAAA</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker_document_data"></mat-datepicker-toggle>
                        <mat-datepicker #picker_document_data></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Denumire Firmă/Societate </mat-label>
                        <input type="text" matInput formControlName="f_nume" />
                        <mat-error *ngIf="
                            !form.controls['f_nume'].valid &&
                            form.controls['f_nume'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>CUI Firmă/Societate</mat-label>
                        <input type="number" matInput formControlName="f_cui" />
                        <mat-error *ngIf="
                            !form.controls['f_cui'].valid &&
                            form.controls['f_cui'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Număr cerere</mat-label>
                        <input type="number" matInput formControlName="cerere_numar" />
                        <mat-error *ngIf="
                            !form.controls['cerere_numar'].valid &&
                            form.controls['cerere_numar'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Dată Cerere</mat-label>
                        <input matInput [matDatepicker]="picker_cerere_data" formControlName="cerere_data" readonly
                            (focus)="picker_cerere_data.open()" />
                        <mat-error *ngIf="
                            !form.controls['cerere_data'].valid &&
                            form.controls['cerere_data'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                        <mat-hint>ZZ/LL/AAAA</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker_cerere_data"></mat-datepicker-toggle>
                        <mat-datepicker #picker_cerere_data></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Sediu Social</mat-label>
                        <textarea type="text" matInput formControlName="f_sediu"></textarea>
                        <mat-error *ngIf="
                            !form.controls['f_sediu'].valid &&
                            form.controls['f_sediu'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Punct de lucru</mat-label>
                        <textarea type="text" matInput formControlName="f_punct_lucru"></textarea>
                        <mat-error *ngIf="
                            !form.controls['f_punct_lucru'].valid &&
                            form.controls['f_punct_lucru'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Valabilitate</mat-label>
                        <input matInput [matDatepicker]="picker_valability" formControlName="valability" readonly
                            (focus)="picker_valability.open()" />
                        <mat-error *ngIf="
                            !form.controls['valability'].valid &&
                            form.controls['valability'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                        <mat-hint>ZZ/LL/AAAA</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker_valability"></mat-datepicker-toggle>
                        <mat-datepicker #picker_valability></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Denumire administrator</mat-label>
                        <input type="text" matInput formControlName="nume_administrator" />
                        <mat-error *ngIf="
                            !form.controls['nume_administrator'].valid &&
                            form.controls['nume_administrator'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div *ngIf="data.registru_slug === 'autorizatie-recreative'">
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Număr Acord/Autorizație</mat-label>
                        <input type="number" matInput formControlName="document_numar" />
                        <mat-error *ngIf="
                            !form.controls['document_numar'].valid &&
                            form.controls['document_numar'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Data eliberării Acord/Autorizație</mat-label>
                        <input matInput [matDatepicker]="picker_document_data" formControlName="document_data" readonly
                            (focus)="picker_document_data.open()" />
                        <mat-error *ngIf="
                            !form.controls['document_data'].valid &&
                            form.controls['document_data'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                        <mat-hint>ZZ/LL/AAAA</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker_document_data"></mat-datepicker-toggle>
                        <mat-datepicker #picker_document_data></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Denumire Firmă/Societate </mat-label>
                        <input type="text" matInput formControlName="f_nume" />
                        <mat-error *ngIf="
                            !form.controls['f_nume'].valid &&
                            form.controls['f_nume'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>CUI Firmă/Societate</mat-label>
                        <input type="number" matInput formControlName="f_cui" />
                        <mat-error *ngIf="
                            !form.controls['f_cui'].valid &&
                            form.controls['f_cui'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Număr cerere</mat-label>
                        <input type="number" matInput formControlName="cerere_numar" />
                        <mat-error *ngIf="
                            !form.controls['cerere_numar'].valid &&
                            form.controls['cerere_numar'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Dată Cerere</mat-label>
                        <input matInput [matDatepicker]="picker_cerere_data" formControlName="cerere_data" readonly
                            (focus)="picker_cerere_data.open()" />
                        <mat-error *ngIf="
                            !form.controls['cerere_data'].valid &&
                            form.controls['cerere_data'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                        <mat-hint>ZZ/LL/AAAA</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker_cerere_data"></mat-datepicker-toggle>
                        <mat-datepicker #picker_cerere_data></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Sediu Social</mat-label>
                        <textarea type="text" matInput formControlName="f_sediu"></textarea>
                        <mat-error *ngIf="
                            !form.controls['f_sediu'].valid &&
                            form.controls['f_sediu'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Punct de lucru</mat-label>
                        <textarea type="text" matInput formControlName="f_punct_lucru"></textarea>
                        <mat-error *ngIf="
                            !form.controls['f_punct_lucru'].valid &&
                            form.controls['f_punct_lucru'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>CAEN</mat-label>
                        <input type="text" matInput formControlName="obiect_activitate" />
                        <mat-error *ngIf="
                            !form.controls['obiect_activitate'].valid && form.controls['obiect_activitate'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Valabilitate</mat-label>
                        <input matInput [matDatepicker]="picker_valability" formControlName="valability" readonly
                            (focus)="picker_valability.open()" />
                        <mat-error *ngIf="
                            !form.controls['valability'].valid &&
                            form.controls['valability'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                        <mat-hint>ZZ/LL/AAAA</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker_valability"></mat-datepicker-toggle>
                        <mat-datepicker #picker_valability></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Suprafață</mat-label>
                        <input type="number" matInput formControlName="suprafata" />
                        <mat-error *ngIf="
                            !form.controls['suprafata'].valid &&
                            form.controls['suprafata'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div *ngIf="data.registru_slug === 'acord-terase-sezoniere'">
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Număr Acord/Autorizație</mat-label>
                        <input type="number" matInput formControlName="document_numar" />
                        <mat-error *ngIf="
                            !form.controls['document_numar'].valid &&
                            form.controls['document_numar'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Data eliberării Acord/Autorizație</mat-label>
                        <input matInput [matDatepicker]="picker_document_data" formControlName="document_data" readonly
                            (focus)="picker_document_data.open()" />
                        <mat-error *ngIf="
                            !form.controls['document_data'].valid &&
                            form.controls['document_data'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                        <mat-hint>ZZ/LL/AAAA</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker_document_data"></mat-datepicker-toggle>
                        <mat-datepicker #picker_document_data></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Denumire Firmă/Societate </mat-label>
                        <input type="text" matInput formControlName="f_nume" />
                        <mat-error *ngIf="
                            !form.controls['f_nume'].valid &&
                            form.controls['f_nume'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>CUI Firmă/Societate</mat-label>
                        <input type="number" matInput formControlName="f_cui" />
                        <mat-error *ngIf="
                            !form.controls['f_cui'].valid &&
                            form.controls['f_cui'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Număr cerere</mat-label>
                        <input type="number" matInput formControlName="cerere_numar" />
                        <mat-error *ngIf="
                            !form.controls['cerere_numar'].valid &&
                            form.controls['cerere_numar'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Dată Cerere</mat-label>
                        <input matInput [matDatepicker]="picker_cerere_data" formControlName="cerere_data" readonly
                            (focus)="picker_cerere_data.open()" />
                        <mat-error *ngIf="
                            !form.controls['cerere_data'].valid &&
                            form.controls['cerere_data'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                        <mat-hint>ZZ/LL/AAAA</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker_cerere_data"></mat-datepicker-toggle>
                        <mat-datepicker #picker_cerere_data></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Punct de lucru</mat-label>
                        <textarea type="text" matInput formControlName="f_punct_lucru"></textarea>
                        <mat-error *ngIf="
                            !form.controls['f_punct_lucru'].valid &&
                            form.controls['f_punct_lucru'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="add-field col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Valabilitate</mat-label>
                        <input matInput [matDatepicker]="picker_valability" formControlName="valability" readonly
                            (focus)="picker_valability.open()" />
                        <mat-error *ngIf="
                            !form.controls['valability'].valid &&
                            form.controls['valability'].touched
                        ">
                            Câmp obligatoriu
                        </mat-error>
                        <mat-hint>ZZ/LL/AAAA</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker_valability"></mat-datepicker-toggle>
                        <mat-datepicker #picker_valability></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col d-flex justify-content-between">
                <button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="form.invalid">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </div>
        </div>
    </form>

    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>